// This file was automatically generated from ptdata.medOrderFills.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.medOrderFills');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.medOrderFills.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.hasTrigger) ? '<a class="fill-detail-trigger" data-id="' + soy.$$escapeHtml(opt_data.id) + '">' : '', (soy.$$escapeHtml(opt_data.lastFillDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.lastFillDate)) : ''), ' ', soy.$$escapeHtml(opt_data.medicationDescription), ', ', soy.$$escapeHtml(opt_data.directions ? ' Sig: ' + opt_data.directions + ', ' : ''), soy.$$escapeHtml(opt_data.quantity ? '#' + opt_data.quantity + ' ' : ''), soy.$$escapeHtml(opt_data.daysSupply ? opt_data.daysSupply + ' days' : ''), soy.$$escapeHtml(opt_data.note ? ' Note: ' + opt_data.note + ', ' : ''), soy.$$escapeHtml(opt_data.pharmacyName ? ' at ' + opt_data.pharmacyName : ''), soy.$$escapeHtml(opt_data.prescriber ? ' by ' + opt_data.prescriber : ''), (opt_data.hasTrigger) ? '</a>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.medOrderFills.displayQuantity = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.quantity), (opt_data.quantityUnit) ? ' ' + soy.$$escapeHtml(opt_data.quantityUnit) : '');
  if (!opt_sb) return output.toString();
};
